import React from 'react'
import {Box} from '@miro-site/core'
import type {BoxProps} from '@miro-site/core'

export interface AccordionProps extends BoxProps {
  children: React.ReactNode
}

const Accordion: React.FC<AccordionProps> = ({children, ...props}) => {
  return <Box {...props}>{children}</Box>
}

export default Accordion
